import React from "react";
import { object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import { getStoryDate } from "../../helper/date-utils";

import "./first-published.m.css";

const FirstPublished = ({ story, publisherName }) => {
  const isRepublished = story["published-at"] !== story["first-published-at"];
  // const firstPublishedTime = formatDate(story["first-published-at"]);
  const firstPublishedTime = getStoryDate(story["first-published-at"]);
  const isLiveBlog = get(story, ["story-template"], "") === "live-blog";

  return isRepublished ? (
    <div styleName="published-wrapper">
      <span styleName="title">Published:&nbsp;</span>
      {!isLiveBlog ? (
        <time
          dateTime={`${new Date(story["first-published-at"]).toISOString().replace("Z", "+00:00")}`}
          styleName="date"
        >
          {firstPublishedTime}
        </time>
      ) : (
        <span
          data-time={`${new Date(story["first-published-at"]).toISOString().replace("Z", "+00:00")}`}
          styleName="date"
          className="published_only"
        >
          {firstPublishedTime}
        </span>
      )}
    </div>
  ) : null;
};

FirstPublished.propTypes = {
  story: object,
  publisherName: string,
};

const mapStateToProps = (state) => ({
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
});

export default connect(mapStateToProps, null)(FirstPublished);
